module.exports = __webpack_public_path__ + "img/专题.a6ca4736.png";